import { Box, IconButton, Tooltip } from '@mui/material';
import { IconEdit } from '@tabler/icons-react';
import { useState } from 'react';
import JiraUserInfo from '../../JiraUserInfo';
import JiraUsersAutocomplete from '../../JiraUsersAutocomplete';
import { useTranslation } from 'react-i18next';

export function Assignee({ assignee, handleChange, jiraUsers }) {
  const { t } = useTranslation();

  const [assigneeEditable, setAssigneeEditable] = useState(false);

  const handleChangeAssignee = (e, val) => {
    handleChange('assignee', val?.accountId);
  };

  const handleAssineeEditToggle = () => {
    setAssigneeEditable((prev) => !prev);
  };

  return assignee && !assigneeEditable ? (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <JiraUserInfo user={assignee} hideActiveInfo />
      <Tooltip title={t('edit')}>
        <IconButton onClick={handleAssineeEditToggle}>
          <IconEdit />
        </IconButton>
      </Tooltip>
    </Box>
  ) : (
    <JiraUsersAutocomplete
      defaultUser={assignee}
      users={jiraUsers}
      handleSelection={handleChangeAssignee}
    />
  );
}
